import type { PaymentMethodSessionOutcome } from '../../../services/commonCheckout/types/SessionOutcome/PaymentMethodSessionOutcome';
import type {
  MessageCallbackArgs,
  MessageCode,
  SessionContext,
} from '../types';

export type GenerateEventObjectArgs = {
  title: MessageCode;
  paymentMethod?: PaymentMethodSessionOutcome | null;
  sessionContext?: SessionContext | null;
};

const generateEventObject = ({
  title,
  paymentMethod,
  sessionContext,
}: GenerateEventObjectArgs): MessageCallbackArgs => {
  const result: MessageCallbackArgs = {
    title,
    code: title,
  };

  if (paymentMethod !== undefined) {
    result.data = {
      paymentMethod,
    };
  } else if (sessionContext !== undefined) {
    result.data = {
      sessionContext,
    };
  }
  return result;
};

export default generateEventObject;
